import type { StateCreator } from 'zustand';
import type { ScenarioResult } from '@gpa-scales/shared-types';

export interface SavedScenario {
  id: string;
  name: string;
  result: ScenarioResult;
  createdAt: string;
}

export interface ScenarioSlice {
  savedScenarios: SavedScenario[];
  saveScenario: (name: string, result: ScenarioResult) => void;
  deleteScenario: (id: string) => void;
}

export const createScenarioSlice: StateCreator<ScenarioSlice> = (set) => ({
  savedScenarios: [],
  saveScenario: (name, result) =>
    set((state) => ({
      savedScenarios: [
        ...state.savedScenarios,
        {
          id: `scenario-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
          name,
          result,
          createdAt: new Date().toISOString(),
        },
      ],
    })),
  deleteScenario: (id) =>
    set((state) => ({
      savedScenarios: state.savedScenarios.filter((s) => s.id !== id),
    })),
});
